import { render, staticRenderFns } from "./loop-settings.vue?vue&type=template&id=b5dd1740&scoped=true"
import script from "./loop-settings.vue?vue&type=script&lang=js"
export * from "./loop-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dd1740",
  null
  
)

export default component.exports